<template>
  <div id="app">
    <common-header />
    <router-view v-if="isRouterAlive" :key="$route.query.t"/>
    <common-footer />
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import CommonFooter from "@/components/CommonFooter.vue";

export default {
  name: 'App',
  components: {
    CommonFooter,
    CommonHeader,
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },

  created() {},

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}
#app {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  li,
  ol,
  span,
  p,
  pre,
  th,
  ul {
    margin: 0;
    padding: 0;
  }
  .title-block {
    height: 200px;
    text-align: center;
  }
// 标题
  .title {
    .title-zh {
      font-weight: 600;
      font-size: 32px;
      padding-bottom: 15px;
    }
    .title-en {
      font-size: 24px;
      font-family: ArialMT;
      color: #222222;
      line-height: 36px;
    }
  }
  .block {
    width: 100%;
    text-align: center;
  }
  // 块内容
  .content {
    padding-top: 100px;
  }
}
.page-content {
  padding: 80px 360px 150px;
}
.B {
  font-weight: 900;
}
/deep/ .el-breadcrumb {
 margin-bottom: 20px;
}
.mid-title {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222220;
  line-height: 48px;
  padding: 40px 0;
}
.big-title {
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222220;
  line-height: 48px;
  padding: 68px 0 18px;
}
.tags {
  display: flex;
  justify-content: space-between;
  .tag {
    text-align: center;
    width: 170px;
    height: 44px;
    line-height: 44px;
    border-radius: 10px;
    background: #0070C0 ;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
  }
  >img {
    width: 250px;
    margin: 40px 0;
  }
}
</style>
